export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8468.feaa1320.jpg";